import PropTypes from 'prop-types'
import styled from 'styled-components'

import colors from 'components/utils/colors'

const StyledWrapper = styled.div`
  && {
    font-size: 12px;
    color: ${colors.secondary20};
    padding: 0 3px 0 1px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    max-width: 80px;
  }
`

const MultiValueLabel = (props) => {
  return (
    <StyledWrapper {...props.innerProps}>
      {props.children}
    </StyledWrapper>
  )
}

MultiValueLabel.propTypes = {
  children: PropTypes.node,
  innerProps: PropTypes.object,
}

export default MultiValueLabel
